"use client";
import React, { useRef } from "react";

export default function FaqFlexiableFullPage({ data }) {
    const questionRefs = useRef([]);
    const answerRefs = useRef([]);

    const toggleAccordions = (i) => {
        if (questionRefs.current[i].classList.contains("active")) {
            questionRefs.current[i].classList.remove("active");
            const element = answerRefs.current[i];
            element.style.height = "0px";
            element.style.overflow = "hidden";
            element.style.transition = "all 0.5s ease-in-out";
            element.style.marginBottom = "0px";
        } else {
            questionRefs.current[i].classList.add("active");
            const element = answerRefs.current[i];
            element.style.height = element.scrollHeight + "px";
            element.style.overflow = "hidden";
            element.style.transition = "all 0.5s ease-in-out";
            element.style.marginBottom = "1.55em";
        }
    };

    return (
        <>
            <section className="page-section ">
                <div className="container relative wow fadeInUp">
                    <div className="row">
                        <div className="col-md-8 offset-md-2">
                            <h2 className="text-2xl font-semibold mb-30">Frequently Asked Questions</h2>
                            <dl className="toggle">
                                {data?.map((item, index) => (
                                    <React.Fragment key={index}>
                                        <dt
                                            onClick={() => {
                                                toggleAccordions(index);
                                            }}
                                        >
                                            <a ref={(el) => (questionRefs.current[index] = el)}>
                                                <h3 className="m-0" style={{fontSize:"20px"}}>{item.question}</h3>
                                            </a>
                                        </dt>
                                        <dd
                                            ref={(el) => (answerRefs.current[index] = el)}
                                            className="black faqAnswer"
                                            style={{
                                                height: "0px",
                                                overflow: "hidden",
                                                marginBottom: "0px",
                                                transition: "all 0.5s ease-in-out",
                                            }}
                                        >
                                            <p className="m-0" style={{fontSize:"18px"}}>{item.answer}</p>
                                        </dd>
                                    </React.Fragment>
                                ))}
                            </dl>
                        </div>

                    </div>
                </div>
            </section >
        </>
    );
}
